import React, { useState } from 'react';
import './NewPostInput.css';
import { UserType } from '../../../../types/userType';
import icon_newpost_input from '../../../../assets/icons/icon_newpost_input.svg';
import AvatarSkeleton from '../../../common/AvatarSkeleton/AvatarSkeleton';

interface NewPostInputProps {
  onOpenModal: () => void;
  currentUser?: UserType | null;
}

const NewPostInput: React.FC<NewPostInputProps> = ({ onOpenModal, currentUser }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="new-post-input" onClick={onOpenModal}>
      {currentUser?.avatar && !imageError ? (
        <>
          <img 
            src={currentUser.avatar}
            alt="Profile"
            className={`profile-picture ${!imageLoaded ? 'hidden' : ''}`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
          />
          {!imageLoaded && <AvatarSkeleton />}
        </>
      ) : (
        <AvatarSkeleton />
      )}
      <div className="input-placeholder">What's sparkling today?</div>
      <img src={icon_newpost_input} alt="New post" className="new-post-icon" />
    </div>
  );
};

export default NewPostInput;